import { MouseEvent, useMemo } from 'react';

import { IMessageAttachment } from '@entities/message/model/types';
import { Image, UiText } from '@shared/ui';

import cls from './ImageAttachments.module.css';

interface IImageAttachmentsProps {
    imgAttachments: IMessageAttachment[];
    onOpenAttachments?: (
        attachments: IMessageAttachment[],
        currentAttachmentId: IMessageAttachment['id']
    ) => void;
}

export const ImageAttachments = ({ imgAttachments, onOpenAttachments }: IImageAttachmentsProps) => {
    const imageCount = useMemo(() => {
        if (imgAttachments.length === 0) return null;
        if (imgAttachments.length === 1) return null;
        return imgAttachments.length - 1;
    }, [imgAttachments?.length]);

    const handleOpenAttachments = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        onOpenAttachments?.(imgAttachments, imgAttachments[0].id);
    };

    if (imgAttachments.length === 0) {
        return null;
    }

    return (
        <div className={cls.ImageAttachmentsContainer} onClick={handleOpenAttachments}>
            <Image
                src={imgAttachments[0]?.originalUrl}
                width="100%"
                height={194}
                className={cls.ImageAttachment}
                wrapperClassName={cls.ImageWrapper}
            />
            <div className={cls.ImageAttachmentsOverlay} />
            {imageCount > 0 && (
                <UiText variant="heading" weight="semibold" className={cls.ImageCounter}>
                    +{imageCount}
                </UiText>
            )}
        </div>
    );
};
